import React, { useEffect } from 'react'
import Wrapper from '../../UI/Wrapper'
import Sidebar from '../../components/Common/Sidebar'
import Main from '../../components/FormScreen/Main'
import Activities from '../../components/Client/Welcome/Activities'
import Bubble from '../../components/Client/Welcome/Bubble'
import { useDispatch, useSelector } from 'react-redux'
import { therapistActions } from '../../services/therapistSlice'
import { useUpdateProfileMutation,useGetTimezonesQuery, useGetCurrentUserQuery } from '../../services/authApi'
import ReactGA from "react-ga"
const tzAliases = {
  'Asia/Calcutta': 'Asia/Kolkata',
   'Asia/Bombay': 'Asia/Kolkata',
   'Asia/Colombo': 'Asia/Colombo',
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
  // Add other known aliases here
   // United States
  'US/Eastern': 'America/New_York',
  'US/Central': 'America/Chicago',
  'US/Mountain': 'America/Denver',
  'US/Pacific': 'America/Los_Angeles',
  'US/Alaska': 'America/Anchorage',
  'US/Hawaii': 'Pacific/Honolulu',
  'Etc/UTC': 'UTC',
  'Etc/GMT': 'GMT',
  'Etc/GMT+0': 'GMT',
  'Etc/GMT-0': 'GMT',
  // Canada
  'Canada/Eastern': 'America/Toronto',
  'Canada/Central': 'America/Winnipeg',
  'Canada/Mountain': 'America/Edmonton',
  'Canada/Pacific': 'America/Vancouver',

  // Australia
  'Australia/Sydney': 'Australia/Sydney',
  'Australia/Melbourne': 'Australia/Melbourne',
  'Australia/Brisbane': 'Australia/Brisbane',
  'Australia/Adelaide': 'Australia/Adelaide',
  'Australia/Perth': 'Australia/Perth',
  'Australia/Hobart': 'Australia/Hobart',
  'Australia/Lord_Howe': 'Australia/Lord_Howe',

  // Europe
  'Europe/Belfast': 'Europe/London',
  'Europe/Tel_Aviv': 'Asia/Jerusalem',
  'Europe/Kyiv': 'Europe/Kiev',
}
const normalizeTz = tz => tzAliases[tz] || tz
const Welcome = () => {
  const { data:userDetails, isError,isLoading:userLoading } = useGetCurrentUserQuery({});

  const { data: timezoneData, isLoading: tzLoading } = useGetTimezonesQuery({})

  const deviceTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
 const dispatch = useDispatch()
const [updateProfile, { isLoading }] = useUpdateProfileMutation();
// console.log(userDetails);

useEffect(() => {
//   console.log("userDetails?.data?.timezone", userDetails?.data?.timezone?.name);
//   console.log("timezoneData?.data", timezoneData?.data);
// console.log(userDetails);
if (userLoading || tzLoading) {
    //   console.log('Still loading data...');
      return;
    }
     if (!userDetails?.data || !timezoneData?.data) {
    //   console.log('Data not available yet');
      return;
    }

  if (!timezoneData?.data) return; 

  const userTz = userDetails?.data?.timezone?.name;
  const normalizedDeviceTz = normalizeTz(deviceTimezone);
  const normalizedUserTz = normalizeTz(userTz);

  //  If user has no timezone, OR timezone differs from device timezone
  if (!userTz || normalizedDeviceTz !== normalizedUserTz) {
 
   const matchedTz = timezoneData.data.find(
      (tz) => tz.name === normalizedDeviceTz
    );

    if (matchedTz) {
    // console.log("jgh");
    
      if (!userDetails?.data?.name || !userDetails?.data?.gender || !userDetails?.data?.dob) {
          // console.error('Missing required user data:', userDetails?.data);
          return;
        }
      
      const formData = new FormData();
      formData.append("name", userDetails?.data?.name);
      formData.append("gender", userDetails?.data?.gender);
      formData.append("dob", userDetails?.data?.dob);
      formData.append("timezone_id", matchedTz.id);

      updateProfile(formData)
        .unwrap()
        .then((res) => {
          localStorage.setItem("device_timezone", normalizedDeviceTz);
        
        })
      
    } else {
     
    }
  }
}, [userDetails, deviceTimezone, timezoneData,userLoading,tzLoading,updateProfile]);


    //Google Analytics
    useEffect( () => {
        ReactGA.pageview(window.location.pathname)
    }, [])

   
    const handleClick = (color) => {
        dispatch(therapistActions.setBG(`bg-[${color}]`))
    }


    return (
        <Wrapper>
            <div className="flex">
                <Sidebar notLoggedIn={false} />
                <Main>

                    {/*  <div className='grid grid-cols-8 gap-6 '>
                        
                        <div className='col-span-2' ><Activities /></div>
                        <div></div>
                     
                        <div className='col-span-4'><Bubble handleClick={handleClick} /></div>
                        <div></div>
                    </div> */}
                    <div className='flex space-x-20 mx-auto '>
                        <Activities />
                        <Bubble handleClick={handleClick} />


                    </div>




                </Main>
            </div>
        </Wrapper>
    )
}

export default Welcome
